// primary actions
export const PACT = {
  ASSIGN_TO_PRODUCT: {
    id: 0,
    action: 'ASSIGN_TO_PRODUCT',
    title: 'Assign to product',
  },
  EDIT_SELECTED: {
    id: 1,
    action: 'EDIT_SELECTED',
    title: 'Edit selected',
  },
  REMOVE_SELECTED: {
    id: 2,
    action: 'REMOVE_SELECTED',
    title: 'Remove selected',
  },
  BULK_EDIT: {
    id: 3,
    action: 'BULK_EDIT',
    title: 'Bulk edit',
  }
};

// secondary actions
export const SACT = {};

// list actions
export const LACT = {
  ADD_TO_LIST: {
    id: 0,
    action: 'ADD_TO_LIST',
    title: 'Add to list',
  },
  REMOVE_FROM_LIST: {
    id: 1,
    action: 'REMOVE_FROM_LIST',
    title: 'Remove from list',
  },
};
